// extracted by mini-css-extract-plugin
module.exports = {"embeddedImage":"_2phUbtW_lAoFAc-zfMbb_j"};